import { combineReducers } from "redux";
import {loaderReducer} from "./loaderReducer";
import {snackbarReducer} from "./snackbarReducer";
import {profileReducer} from "./profileReducer";
import {titleReducer} from "./titleReducer";

const reducers = combineReducers({
    loading: loaderReducer,
    snackbar: snackbarReducer,
    title: titleReducer,
    profile: profileReducer
})

export default reducers;

export type RootState = ReturnType<typeof reducers>;